import(/* webpackMode: "eager" */ "/opt/build/repo/client/components/downloads/downloads.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/client/styles/downloads.module.css");
